import { Component, Inject, Input, OnInit, forwardRef } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { hasEventDetailsContext } from "../../common/helper";
import { EventDetailsPageDialogComponent } from "../../dashboard-area/event-details/event-details-page-dialog.component";
import { Alert } from "../../model";
import { DurationFormatterPipe } from "../../shared/pipe";
import { EventSeverityPipe } from "../../shared/pipe/event-severity.pipe";

@Component({
    selector: 'daily-summary-grid-widget-event-details',
    template: require('./daily-summary-grid-widget-event-details.component.html'),
    styles: [require('./daily-summary-grid-widget-event-details.component.css')]
})
export class DailySummaryGridWidgetEventDetailsComponent implements OnInit {

    @Input() set data(data: Alert[]) {
        this._data = data;
        this.computeTableData();
    }

    @Input() timezone: string;

    @Input() locale: string;

    visibleColumns: string[];
    tableData: Alert[];
    _data: Alert[];
    clickableTable: boolean;
    dataLoaded: boolean;

    constructor(
        @Inject(forwardRef(() => EventSeverityPipe)) private eventSeverityPipe: EventSeverityPipe,
        @Inject(forwardRef(() => DurationFormatterPipe)) private durationFormatterPipe: DurationFormatterPipe,
        @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog
    ) { }

    ngOnInit(): void {
        this.visibleColumns = ['title', 'severity', 'duration', 'start', 'end'];
    }

    private computeTableData(): void {
        this.dataLoaded = false;
        if (this._data?.length) {
            let tableData = this._data;
            tableData.sort((a, b) => a.startTimestamp - b.startTimestamp);
            tableData.forEach(e => {
                e['printedSeverity'] = this.eventSeverityPipe.transform(e['eventSeverity']);
                e['duration'] = this.durationFormatterPipe.transform({ startTimestamp: e.startTimestamp, endTimestamp: e.endTimestamp });
            });
            this.clickableTable = tableData.some(event => hasEventDetailsContext(event));
            this.tableData = tableData;
            this.dataLoaded = true;
        } else {
            this.tableData = [];
            this.dataLoaded = true;
        }
    }

    openEventDetails(element: Alert): void {
        if (!hasEventDetailsContext(element)) {
            return;
        }
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '25%';
        dialogConfig.width = '600px';
        dialogConfig.data = { id: element.id, isHistorical: !!element.endTimestamp };
        this.dialog.open(EventDetailsPageDialogComponent, dialogConfig);
    }
}